import React from 'react';
import styles from './style.module.scss';
import { listingCardIds } from 'constants/test-constants';
import { buildClassName } from 'utils/build-class-name';
import { getMlsNumberPrefix } from 'ui/mls-info/format-mls-info';

export type ProviderLabelsProps = {
  mlsNum: string | null;
  /** Feed the listing came from — decides the listing-number prefix. */
  providerId?: number | null;
  brokerage: string | null;
  hasLogo?: boolean;
  isBlurred?: boolean;
};

export default function ProviderLabels({ mlsNum, providerId, brokerage, hasLogo = false, isBlurred = false }: ProviderLabelsProps) {
  const labelClass = buildClassName(styles.label, hasLogo ? styles['has-logo'] : styles['no-logo']);

  if (!mlsNum) {
    return null;
  }

  return (
    <p className={labelClass}>{getMlsNumberPrefix(providerId)}&nbsp;
      <span className={isBlurred ? styles.blur : ''} data-testid={listingCardIds.listingMlsNum}>{mlsNum} {brokerage && !isBlurred ? `• ${brokerage}` : ''}</span>
    </p>
  );
}
